module.exports = __webpack_public_path__ + "img/Flag_of_Argentina.3036121f.svg";